import React from 'react';
import UnifiedResetPassword from '@components/UnifiedResetPassword';

const ResetPasswordWithToken: React.FC = () => {
  return <UnifiedResetPassword theme="light" />;
};

export default ResetPasswordWithToken;
